import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import { BsPersonPlusFill } from "react-icons/bs";
import { AiFillEye, AiFillEyeInvisible, AiFillLock } from "react-icons/ai";
import Logo from "../../Resources/Images/LoginPage.png";
// import axios from "../../HOC/Axios/Axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import cookies from "js-cookie";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "../../HOC/Axios/Axios";
import { FaTradeFederation } from "react-icons/fa";
// import Spinner from "../../components/pageComponents/Spinner/Spinner";
import Loader from "../../components/pageComponents/Spinner/loader";
function Login() {
  const router = useNavigate();
  const [clickEyeButton, setClickEyeButton] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const LoginForm = [
    {
      id: 0,
      type: "email",
      label: "Enter email address",
      placeholder: "Enter email address",
      apikey: "email",
      autocomplete: "on",
      icon: <BsPersonPlusFill />,
    },
    {
      id: 1,
      type: "password",
      label: "Password",
      placeholder: "Password",
      apikey: "password",
      icon: <AiFillLock />,
    },
  ];
  const LoginSchema = yup.object().shape({
    email: yup.string().email("Invalid email").required("Email is required"),
    password: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Password is required"),
  });

  const submit = (values) => {
    console.log(values);
    setShowSpinner(true);
    axios
      .post("/admin/login", values)
      .then((res) => {
        if (res.status === 201) {
          toast.success("Login sucessfully", { toastId: "AddedSuccess" });
          // (res.data.token);
          cookies.set("adminToken", res.data.token);
          setShowSpinner(false);

          setTimeout(() => {
            router("/");
          }, 1500);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log(err.message);
        toast.error(err.message, { toastId: "Error" });
        setShowSpinner(false);
      });
  };

  const showText = () => {
    setClickEyeButton(!clickEyeButton);
  };
  const [focusedInput, setFocusedInput] = useState("");
  const handleInputFocus = (id) => {
    setFocusedInput(id);
  };
  const handleInputBlur = () => {
    setFocusedInput(null);
  };
  useEffect(() => {
    // Disable scrolling when the component mounts
    document.body.style.overflow = "hidden";

    // Re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="tablet:grid grid-cols-12 tablet:h-fit min-h-screen">
      <div className="col-span-7 tablet:block hidden w-full h-fit relative">
        {showSpinner && <Loader />}
        <ToastContainer autoClose={1000} pauseOnHover={false} />
        <div className="relative w-full laptopM:py-0">
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent z-10" />
          <div className="absolute left-[10%] top-[200px] z-20">
            <div className="text-4xl font-bold tracking-tight text-white drop-shadow-lg">
              Crypto Trading Made Simple
            </div>
            <div className="text-base text-white/90 mt-5 max-w-md leading-relaxed">
              Manage deposits, withdrawals, and settlements from one powerful admin dashboard.
            </div>
          </div>
          <img
            alt="Crypto"
            src={Logo}
            width={100}
            height={10}
            className="h-[820px] w-full object-cover overflow-hidden object-top"
          />
        </div>
      </div>
      <div className="col-span-5 px-8 py-16 flex items-center justify-center min-h-screen overflow-auto bg-slate-50 relative">
        <div className="w-full max-w-md">
        <div className="flex items-center gap-4 mb-10">
          <div className="bg-sidebar rounded-2xl p-3 shadow-xl">
            <FaTradeFederation className="text-5xl text-violet-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-800 tracking-tight">Uni Trading</h1>
            <p className="text-sm text-slate-500">Admin Dashboard</p>
          </div>
        </div>
        <div className="mb-2">
          <h2 className="text-2xl font-bold text-slate-800">Welcome back</h2>
          <p className="text-slate-500 mt-1">Sign in to your admin account</p>
        </div>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={LoginSchema}
          onSubmit={(values) => {
            console.log(values);
            submit(values);
          }}
        >
          {({ errors, touched, values }) => (
            <Form className=" w-full mx-auto">
              <div className="  w-full  ">
                {" "}
                {LoginForm.map((val, i) => {
                  return (
                    <div key={i} className="my-6 w-full">
                      <div className="relative  ">
                        <div className="relative">
                          <label
                            onClick={(e) => handleInputFocus(val.id)}
                            htmlFor={val.apikey}
                            className={`absolute tracking-wider ${
                              focusedInput === val.id ||
                              values[val.apikey] !== ""
                                ? "top-1 text-[13px] font-normal"
                                : "top-5 text-[15px] font-medium "
                            } left-4 transition-all ease-in-out duration-300 text-slate-500 `}
                          >
                            {val.label}
                          </label>

                          {/* {val.label}
                          </div> */}
                          <Field
                            id={val.apikey}
                            onClick={() => handleInputFocus(val.id)}
                            onBlur={handleInputBlur}
                            name={val.apikey}
                            type={
                              !clickEyeButton && val.apikey === "password"
                                ? (val.type = "password")
                                : (val.type = "text")
                            }
                            autoComplete={
                              val.apikey === "password"
                                ? val.autocomplete
                                : null
                            }
                            // placeholder={val.placeholder}
                            className={`px-4 text-sm h-12 outline-none w-full rounded-xl bg-white border transition-all
                           ${
                             focusedInput === val.id || values[val.apikey] !== ""
                               ? "border-secondMainColor ring-2 ring-secondMainColor/20 shadow-sm"
                               : "border-slate-200 hover:border-slate-300"
                           }
                            `}
                          />
                          {val.apikey === "password" ? (
                            <div className="absolute top-5 right-5 z-50">
                              {clickEyeButton ? (
                                <button
                                  type="button"
                                  onClick={() => showText()}
                                >
                                  <AiFillEye className="text-xl" />
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => showText()}
                                >
                                  <AiFillEyeInvisible className="text-xl" />
                                </button>
                              )}
                            </div>
                          ) : null}
                        </div>
                        {/* <div
                          className="text-white p-[9px] bg-[#833CDC] absolute top-0
                             left-0 rounds text-2xl"
                        >
                          {val.icon}
                        </div> */}
                      </div>
                      {errors[val.apikey] && touched[val.apikey] && (
                        <div className="mt-2 text-red-400 text-sm px-2 py-1 rounded-sm">
                          {errors[val.apikey]}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div>
                {" "}
                <NavLink to={"/forgotPassword"}>
                  <div className="text-center text-sm text-secondMainColor hover:text-secondMainColor/80 cursor-pointer hover:underline font-medium mt-2 mb-6 transition-colors">
                    Forgot password?
                  </div>
                </NavLink>
              </div>
              <div className="">
                <button
                  className="w-full h-12 px-4 bg-sidebar hover:bg-slate-800 text-white font-semibold rounded-xl transition-all shadow-lg"
                  type="submit"
                >
                  Sign in
                </button>
              </div>
            </Form>
          )}
        </Formik>
        </div>
      </div>
    </div>
  );
}

export default Login;
